(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFleetsDeleteController',TabFleetsDeleteController);

    TabFleetsDeleteController.$inject = ['$uibModalInstance', 'entity', 'TabFleets'];

    function TabFleetsDeleteController($uibModalInstance, entity, TabFleets) {
        var vm = this;
        vm.tabFleets = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TabFleets.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
